import useMediaQuery from '@mui/material/useMediaQuery';
import {DefaultThemeName} from '../themes';
import {SimpleThemeName} from '#common/theme/themes';

const PrefersColorScheme = 'prefers-color-scheme';

/* v8 ignore start */
export function useSystemTheme(): SimpleThemeName {
  const prefersLight = useMediaQuery(`(${PrefersColorScheme}: light)`);
  const prefersDark = useMediaQuery(`(${PrefersColorScheme}: dark)`);
  if (prefersLight) {
    return 'light';
  } else if (prefersDark) {
    return 'dark';
  }
  return DefaultThemeName;
}
/* v8 ignore stop */
